<template>
  <div class="before-head-body">
    <header-nav />
    <div class="before-head-login" v-if="!userInfo">
      <!-- <span>我的场景</span> -->
      <a-button class="login-btn" @click="loginBtn">登录</a-button>
      <a-button class="registered-btn" @click="registered">账号申请</a-button>
    </div>
    <div class="before-head-user" v-else>
      <a-dropdown
        :trigger="['click']"
        placement="bottomRight"
        overlay-class-name="layout-header-consult-body"
      >
        <div @click="(e) => e.preventDefault()" class="layout-header-consult">
          <span><a-icon type="message" /> 场景咨询</span>
          <a-icon type="caret-down" />
        </div>
        <a-menu slot="overlay">
          <a-menu-item>
            <div class="layout-header-consult-title">
              <span><a-icon type="heart" theme="filled" /></span>场景咨询
            </div>
          </a-menu-item>
          <a-menu-item>
            <p class="layout-header-user-btn" @click="consult('1')">
              场景寻源咨询
            </p>
          </a-menu-item>
          <a-menu-item>
            <p class="layout-header-user-btn" @click="consult('2')">
              场景辅导咨询
            </p>
          </a-menu-item>
          <a-menu-item>
            <p class="layout-header-user-btn" @click="consult('3')">
              揭榜寻源咨询
            </p>
          </a-menu-item>
        </a-menu>
      </a-dropdown>
      <!-- <span @click="myScene">我的场景</span> -->
      <a-dropdown :trigger="['click']" placement="bottomRight">
        <div @click="(e) => e.preventDefault()" class="layout-header-user-info">
          <span
            ><v-img
              :attachment-id="userInfo.logoId"
              :default-img="require('@/assets/img/defaultavatar.png')"
          /></span>
          <a-icon type="caret-down" />
        </div>
        <a-menu slot="overlay">
          <a-menu-item>
            <p class="layout-header-user-btn" @click="userHome">
              <img src="@/assets/img/shouye.png" />
              用户首页
            </p>
          </a-menu-item>
          <a-menu-item>
            <p class="layout-header-user-btn" @click="setUp">
              <img src="@/assets/img/zhanghao.png" />
              账号设置
            </p>
          </a-menu-item>
          <a-menu-item>
            <p class="layout-header-user-btn" @click="signOut">
              <img src="@/assets/img/tuichudenglu.png" />
              退出登录
            </p>
          </a-menu-item>
        </a-menu>
      </a-dropdown>
      <consult-form
        v-if="consultShow"
        :show="consultShow"
        :type="consultType"
        v-model="consultShow"
      />
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import consultForm from "../consult/consultForm.vue";
import VImg from "@/components/VImg";
import HeaderNav from "@/page/beforeLayout/HeaderNav";

export default {
  components: {
    HeaderNav,
    VImg,
    consultForm,
  },
  data() {
    return {
      login: false,
      headerNav: [
        {
          title: "首页",
          url: "/homeIndex",
        },
        {
          title: "场景",
          url: "/homeScenes",
        },
        {
          title: "动态",
          url: "/homeDynamic",
        },
        {
          title: "活动",
          url: "/homeActivity",
        },
        {
          title: "成果",
          url: "/homeResults",
        },
        {
          title: "知识云",
          url: "/homeKnowledge",
        },
      ],
      headerNavIndex: 0,
      consultType: "",
      consultShow: false,
    };
  },
  computed: {
    ...mapGetters(["userInfo"]),
  },
  mounted() {},
  methods: {
    consult(type) {
      this.consultType = type;
      this.consultShow = true;
    },
    registered() {
      this.$router.push("/registered");
    },
    myScene() {
      this.$router.push("/after/myScenes");
    },
    loginBtn() {
      this.$router.push("/login");
    },
    userHome() {
      this.$router.push("/after");
    },
    signOut() {
      let _this = this;
      this.$confirm({
        title: "确定退出登录?",
        okText: "确定",
        cancelText: "取消",
        onOk() {
          _this.$store.dispatch("Logout");
        },
        onCancel() {
          console.log("Cancel");
        },
      });
    },
    setUp() {
      this.$router.push("/after/setting");
    },
  },
};
</script>

<style lang="less" scoped>
.before-head-body {
  height: 64px;
  background: #1d1d1d;
  padding: 0 24px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  color: #fff;

  .before-head-login {
    display: flex;
    align-items: center;

    > span {
      line-height: 14px;
      margin-right: 40px;
      cursor: pointer;
    }

    > button {
      width: 80px;
      height: 32px;
      border-radius: 2px;
      color: #fff;
      font-size: 14px;
      padding: 0;
      text-align: center;
    }

    .login-btn {
      background: none;
      border: 1px solid rgba(255, 255, 255, 0.24);
    }

    .registered-btn {
      border: none;
      background: #1abc9c;
      margin-left: 16px;
    }
  }

  .before-head-user {
    display: flex;
    align-items: center;

    > span {
      color: #fff;
      margin-right: 40px;
      cursor: pointer;
    }

    .layout-header-user-info {
      display: flex;
      align-items: center;
      cursor: pointer;
      height: 64px;

      > span {
        width: 40px;
        height: 40px;
        border-radius: 50%;
        overflow: hidden;
        margin-right: 16px;

        > img {
          display: block;
          height: 100%;
          height: 100%;
        }
      }

      > i {
        color: #fff;
        font-size: 12px;
      }
    }
  }
}

.layout-header-consult {
  display: flex;
  align-items: center;
  margin-right: 40px;
  cursor: pointer;
  height: 64px;

  > i {
    margin-left: 10px;
    font-size: 12px;
  }

  > span {
    display: flex;
    align-items: center;

    > i {
      margin-right: 6px;
    }
  }
}

.layout-header-consult-title {
  display: flex;
  align-items: center;
  color: #fff;
  font-size: 16px;

  > span {
    background: #1abc9c;
    width: 24px;
    height: 24px;
    color: #fff;
    border-radius: 6px;
    text-align: center;
    line-height: 24px;
    margin-right: 10px;
  }
}
</style>
<style>
.layout-header-consult-body {
  top: 64px !important;
  width: 184px;
  border-radius: 0 !important;
}

.layout-header-consult-body .ant-dropdown-menu {
  border-radius: 0 !important;
}

.layout-header-consult-body
  .ant-dropdown-menu
  .ant-dropdown-menu-item:first-child {
  padding: 16px;
  background: #1e232e;
  margin-top: -4px;
}
</style>
